import Spinner from 'react-bootstrap/Spinner'
import './Loader/Loader.scss'
export const AppLoader = () => {
    return (
        <div className='align-center'>
        <Spinner animation="border" variant="primary" />
        </div>
    )
}